import { IdentityProviders } from 'korint-sdk/react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { AuthLayout } from '../auth-layout';
import { EmailCheckForm } from '../email-check-form';
import { useAuthRedirect } from '../useAuthRedirect';
import { useOnAlreadyAuthenticated } from '../useOnAlreadyAuthenticated';

export const EmailCheckView = ({
  logo,
  providers = [],
  showLastLoginHint = false,
  link,
}: {
  logo: ReactNode;
  providers: IdentityProviders[];
  showLastLoginHint?: boolean;
  link?: { label: string; to: string };
}) => {
  const { t } = useTranslation();
  const { isLoading } = useOnAlreadyAuthenticated();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { redirectSearch } = useAuthRedirect();
  const defaultEmail = searchParams.get('email') ?? undefined;

  if (isLoading) {
    return null;
  }

  return (
    <AuthLayout title={t('authSignIn.welcomeTitle')} logo={logo}>
      <EmailCheckForm
        providers={providers}
        showLastLoginHint={showLastLoginHint}
        defaultEmail={defaultEmail}
        onResult={({ status, email }) => {
          const encodedEmail = encodeURIComponent(email);
          if (status === 'CONFIRMED') {
            navigate({
              pathname: '/auth/sign-in',
              search: `email=${encodedEmail}&${redirectSearch}`,
            });
          } else {
            navigate({
              pathname: '/auth/setup-password',
              search: `email=${encodedEmail}&${redirectSearch}`,
            });
          }
        }}
      />
      {link && (
        <Link to={link.to} className="block text-center text-sm text-primary underline">
          {link.label}
        </Link>
      )}
    </AuthLayout>
  );
};
